// Format: Month Day, Year in PST timezone
const formatDateInPST = () => {
  const options = { 
    timeZone: 'America/Los_Angeles',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };
  return new Date().toLocaleDateString('en-US', options);
};

export const GAME_TITLE = `Connections: ${formatDateInPST()}`;
export const MAX_MISTAKES = 5;
export const PROPOSAL_WORDS = ["Will", "you", "marry", "me?"];
